import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import Layout from "../Components/Layout";
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUserProfile, fetchUserSubscriptions, uploadPortalFile, getPortalFiles, requestPasswordResetOTP, confirmPasswordReset, resendConfirmationOTP, getSubscriptionDetails, updateRouterDetails  } from '../apiService';
import { useGlobalError } from '../Components/GlobalErrorContext';
// import { useFeedback } from "../Components/FeedbackContext";

const Profile: React.FC = () => {
    const [profileData, setProfileData] = useState({
        firstName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        streetAddress: '',
        suburb: '',
        postalAddress: '',
        identificationReference: '',
        unitNumber: '', 
    });
    const [subscriptionData, setSubscriptionData] = useState({
        status: '',
        accountReference: '',
    });

    const [routerDetails, setRouterDetails] = useState({
      portalSubscriptionId: null,
      ssid: "",
      password: "",
    });

    // const { showFeedbackModal } = useFeedback();
    const { showErrorModal } = useGlobalError();

    const [uploadedFiles, setUploadedFiles] = useState<{
  [key: string]: {
    fileUrl: string; fileName: string; url?: string 
};
}>({});

    const [identityFile, setIdentityFile] = useState<File | null>(null);
    const [addressFile, setAddressFile] = useState<File | null>(null);
    const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
    const [confirmationPin, setConfirmationPin] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [oldPassword, setOldPassword] = useState('');

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [passwordResetError, setPasswordResetError] = useState('');
    const [passwordResetSuccess, setPasswordResetSuccess] = useState('');

    const [showRouterUpdateModal, setShowRouterUpdateModal] = useState(false);
    const [newRouterSSID, setNewRouterSSID] = useState('');
    const [newRouterPassword, setNewRouterPassword] = useState('');
    const [confirmRouterPassword, setConfirmRouterPassword] = useState('');
    const [showWifiPassword, setShowWifiPassword] = useState(false);
    const [routerUpdateError, setRouterUpdateError] = useState('');
    const [routerUpdateSuccess, setRouterUpdateSuccess] = useState('');
    const [showConfirmWifiPassword, setShowConfirmWifiPassword] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false); // FIX: was used in JSX but never declared

    const navigate = useNavigate();
    const location = useLocation(); 

    // useEffect(() => {
    //   const hasSeen = localStorage.getItem("seenFeedbackPopup");

    //   if (!hasSeen) {
    //     showFeedbackModal();
    //     localStorage.setItem("seenFeedbackPopup", "true");
    //   }
    // }, []);

    // const lastShown = localStorage.getItem("feedbackPopupDate");
    // const today = new Date().toDateString();

    // if (lastShown !== today) {
    //   showFeedbackModal();
    //   localStorage.setItem("feedbackPopupDate", today);
    // }

    // Fetch user profile on component mount
    useEffect(() => {
        const accessToken = localStorage.getItem('accessToken');
        const portalEndCustomerId = localStorage.getItem('portalEndCustomerId');
      
        if (!accessToken || !portalEndCustomerId) {
          navigate('/login'); // Redirect to login if no credentials
          return;
        }
      
        const fetchData = async () => {
          try {
            await Promise.all([
              (async () => {
                const userProfile = await fetchUserProfile(portalEndCustomerId); // Fetch user profile
                setProfileData({
                  firstName: userProfile.firstName,
                  lastName: userProfile.lastName,
                  mobileNumber: userProfile.mobileNumber,
                  email: userProfile.email,
                  streetAddress: userProfile.streetAddress,
                  suburb: userProfile.suburb,
                  postalAddress: userProfile.postalAddress,
                  identificationReference: userProfile.identificationReference,
                  unitNumber: userProfile.unitNumber, // Handle optional field
                });
              })(),
              (async () => {
                const userSubscriptions = await fetchUserSubscriptions(portalEndCustomerId);
                console.log("Fetched Subscriptions:", userSubscriptions);

                if (userSubscriptions.length > 0) {
                  const subscription = userSubscriptions[0];

                  setSubscriptionData({
                    status: subscription.status,
                    accountReference: subscription.accountReference,
                  });

                  // Store subscription ID in state and localStorage
                  setRouterDetails((prev) => ({
                    ...prev,
                    portalSubscriptionId: subscription.id,
                  }));
                  localStorage.setItem("portalSubscriptionId", subscription.id);

                  // Fetch router details using subscription ID
                  const routerResult = await getSubscriptionDetails(subscription.id);
                  if (routerResult.success) {
                    setRouterDetails((prev) => ({
                      ...prev,
                      ssid: routerResult.data.wifi_ssid,
                      password: routerResult.data.wifi_password,
                    }));
                  } else {
                    console.warn("Failed to fetch router details:", routerResult.message);
                  }
                }
              })(),
            ]);
            await fetchUploadedFiles(); 
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      
        fetchData();
      }, [navigate, location]);
    

      const handleFileUpload = async () => {
        const portalEndCustomerId = localStorage.getItem('portalEndCustomerId');
        if (!portalEndCustomerId) {
          showErrorModal('Please ensure you are logged in.');
          return;
        }

        try {

          if (identityFile) {
            const identityResult = await uploadPortalFile(portalEndCustomerId, 'identity_document', identityFile);
            if (identityResult.success) {
              alert('Identity file uploaded successfully!'); // or implement success modal later
            } else {
              showErrorModal(`Identity file upload failed: ${identityResult.message}`);
            }
          }

          if (addressFile) {
            const addressResult = await uploadPortalFile(portalEndCustomerId, 'residential_address', addressFile);
            if (addressResult.success) {
              alert('Address file uploaded successfully!');
              await fetchUploadedFiles(); 
            } else {
              showErrorModal(`Address file upload failed: ${addressResult.message}`);
            }
          }

          if (!identityFile && !addressFile) {
            showErrorModal('Please select at least one file to upload.');
          }
        } catch (error) {
          console.error('Error uploading files:', error);
          showErrorModal('An unexpected error occurred. Please try again.');
        } finally {
        }
      };

        const fetchUploadedFiles = async () => {
          const portalEndCustomerId = localStorage.getItem('portalEndCustomerId');
          if (!portalEndCustomerId) return;

          const result = await getPortalFiles(portalEndCustomerId);

          if (result.success && Array.isArray(result.data)) {
            const filesByType: { [key: string]: { fileUrl: string; fileName: string; url?: string } } = {};

            result.data.forEach((file: any) => {
              const fileUrl = `https://stm-dev.intentio.co.za/api/user/download/${file.unique_file_reference}`;
              filesByType[file.document_type] = {
                fileUrl,
                fileName: file.original_filename,
              };
            });

            setUploadedFiles(filesByType);
          } else {
            console.error('Failed to fetch uploaded files:', result.message);
          }
        };

    const handlePortalPasswordReset = async () => {
    try {
        const result = await requestPasswordResetOTP(profileData.email, profileData.mobileNumber);
        if (result.success) {
          alert(result.message);
          setShowPasswordResetModal(true);
        } else {
          showErrorModal(result.message);
        }
      } catch (error) {
        showErrorModal('Failed to request OTP for password reset.');
      }
    };

  const handlePasswordResetSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setPasswordResetError('');
    setPasswordResetSuccess('');

    if (newPassword !== confirmPassword) {
      setPasswordResetError("New password and confirmation do not match.");
      return;
    }

    try {
      const result = await confirmPasswordReset({
        confirmation_pin: confirmationPin,
        new_password: newPassword,
        old_password: oldPassword,
      });

      if (result.success) {
        setPasswordResetSuccess("Password reset successfully.");
        setTimeout(() => {
          setShowPasswordResetModal(false);
          setConfirmationPin('');
          setNewPassword('');
          setConfirmPassword('');
          setOldPassword('');
          setPasswordResetSuccess('');
        }, 3000);
      } else {
        setPasswordResetError(result.message);
      }
    } catch (error) {
      setPasswordResetError("An unexpected error occurred. Please try again.");
    }
  };

  
  const handleResendPortalOTP = async () => {
    const portalEndCustomerId = localStorage.getItem('portalEndCustomerId');
    if (!portalEndCustomerId) {
      setPasswordResetError("User ID not found.");
      return;
    }

    const result = await resendConfirmationOTP(portalEndCustomerId);
    if (result.success) {
      setPasswordResetSuccess("OTP resent successfully.");
    } else {
      setPasswordResetError(result.message);
    }
  };

  const handleRouterUpdateSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setRouterUpdateError("");
    setRouterUpdateSuccess("");

    if (newRouterPassword !== confirmRouterPassword) {
      setRouterUpdateError("Password and confirmation do not match.");
      return;
    }

    const subscriptionId =
      routerDetails.portalSubscriptionId ||
      localStorage.getItem("portalSubscriptionId");

    if (!subscriptionId) {
      setRouterUpdateError("Subscription ID not found. Please refresh the page.");
      return;
    }

    setIsUpdating(true); // FIX: disable the button while saving
    try {
      const result = await updateRouterDetails(
        parseInt(subscriptionId),
        newRouterSSID,
        newRouterPassword
      );

      if (result.success) {
        setRouterUpdateSuccess("Router details updated successfully.");
        setRouterDetails((prev) => ({
          ...prev,
          ssid: result.data.wifi_ssid,
          password: result.data.wifi_password,
        }));

        setTimeout(() => {
          setShowRouterUpdateModal(false);
          setNewRouterSSID("");
          setNewRouterPassword("");
          setConfirmRouterPassword("");
          setRouterUpdateSuccess("");
        }, 2500);
      } else {
        setRouterUpdateError(result.message || "Failed to update router details.");
      }
    } catch (err) {
      setRouterUpdateError("An unexpected error occurred. Please try again.");
    } finally {
      setIsUpdating(false); // FIX: always re-enable, success or failure
    }
  };


return (
        <Layout>
        <div className="application-form container" id="application-form-page">  
            {/* Account Status and Account Number */}
            <div className="row align-items-end ">
            <div className="col-md-12">
                <div className="d-flex flex-column align-items-end">
                    <div className="mb-3">
                    <label className="fw-bold" style={{ color: '#e56521' }}>
                        Account Status
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={subscriptionData.status.toUpperCase()} // Dynamically display subscription_status
                        readOnly
                        style={{ width: '200px' }}
                    />
                    </div>
                    <div>
                    <label className="fw-bold" style={{ color: '#e56521' }}>
                        Account Number
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={subscriptionData.accountReference} // Dynamically display account_reference
                        readOnly
                        style={{ width: '200px' }}
                    />
                </div>
                </div>
            </div>
            </div>

            {/* Personal & Address Information Section */}
            <div className="form-section">
                <br />
                <h4 style={{ margin: 0 }}>PERSONAL DETAILS</h4>
                <hr />
                {/* Name Section */}
                <div className="row">
                    <div className="col-md-6">
                        <label>First Name</label>
                        <input type="text" name="firstName" value={profileData.firstName} readOnly />
                    </div>
                    <div className="col-md-6">
                        <label>Last Name</label>
                        <input type="text" name="lastName" value={profileData.lastName} readOnly />
                    </div>
                </div>

                {/* ID Section */}
                <label>Identity Number (SA) / Passport Number (NON-SA)</label>
                <input type="text" name="idNumber" value={profileData.identificationReference}  readOnly />

                {/* Address Section */}
                <div className="row">
                    <div className="col-md-6">
                        <label>Complex/House/Business</label>
                        <input type="text" name="complex" value={profileData.streetAddress} readOnly />
                    </div>
                    <div className="col-md-6">
                        <label>Suburb</label>
                        <input type="text" name="suburb" value={profileData.suburb} readOnly />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label>Unit Number</label>
                        <input type="text" name="unitNumber" value={profileData.unitNumber}  readOnly />
                    </div>
                    <div className="col-md-6">
                        <label>Street Address</label>
                        <input type="text" name="streetAddress" value={profileData.streetAddress} readOnly />
                    </div>
                </div>

                <label>Postal Address</label>
                <textarea name="postalAddress" rows={2} value={profileData.postalAddress} readOnly></textarea>

                <div className="row">
                    <div className="col-md-6">
                        <label>Mobile Number</label>
                        <input type="tel" name="mobileNumber" value={profileData.mobileNumber} readOnly />
                    </div>
                    <div className="col-md-6">
                        <label>Email</label>
                        <input type="email" name="email" value={profileData.email} readOnly />
                    </div>
                </div>
            </div>

            <br />
            {/* Router Details Section */}
            <div className="application-form container form-section" id="application-form-page">
              <br />
              <h4 style={{ margin: 0 }}>ROUTER DETAILS</h4>
              <hr />
              <div className="row">
                <div className="col-md-6">
                  <label>Router SSID Username</label>
                  <input
                    type="text"
                    name="ssidusername"
                    value={routerDetails.ssid}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Router SSID Password</label>
                  <input
                    type="text"
                    name="ssidpassword"
                    value={routerDetails.password}
                    readOnly
                    className="form-control"
                  />
                </div>
              </div>
              <hr />
              <div style={{ textAlign: 'left', margin: '0' }}>
              <button
                className="btn btn-success "
                // style={{ width: "30%", backgroundColor: "#e56521", borderColor: "#ec4d13" }}
                onClick={() => {
                  setNewRouterSSID(routerDetails.ssid);
                  setNewRouterPassword(routerDetails.password);
                  setConfirmRouterPassword('');
                  setShowRouterUpdateModal(true);
                }}
              >
                Reset Router Details
              </button>


              </div>
            </div>
            <br/>

            {/* RICA Documents Section */}
            <div className="form-section">
                <br />
                <h4 style={{ margin: 0 }}>RICA DOCUMENTS</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                      <label>Identity or Passport</label>
                      <input
                        type="file"
                        name="identityFile"
                        onChange={(e) => setIdentityFile(e.target.files?.[0] || null)}
                        style={{ backgroundColor: '#e56521' }}
                      />
                      {uploadedFiles.identity_document && (
                            <div className="mt-0">
                              <a
                                href={uploadedFiles.identity_document.fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {uploadedFiles.identity_document.fileName}
                              </a>
                            </div>
                      )}

                    </div>

                    <div className="col-md-6">
                      <label>Proof of Residential Address</label>
                      <input
                        type="file"
                        name="addressFile"
                        onChange={(e) => setAddressFile(e.target.files?.[0] || null)}
                        style={{ backgroundColor: '#e56521' }}
                      />
                      {uploadedFiles.residential_address && (
                            <div className="mt-0">
                              <a
                                href={uploadedFiles.residential_address.fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {uploadedFiles.residential_address.fileName}
                              </a>
                            </div>
                      )}

                    </div>

                </div>
                <hr />
                <div style={{ textAlign: 'left', margin: '0' }}>
                    <button
                        className="btn btn-primary "
                        // style={{ width: '30%', backgroundColor: '#e56521', borderColor: '#ec4d13' }}
                        onClick={handleFileUpload}
                    >
                        Upload Files
                    </button>
                </div>
            </div>
            <br />

            {/* Change Portal Password Section */}
            <div className="form-section">
              <br />
              <h4 style={{ margin: 0 }}>CHANGE PORTAL PASSWORD</h4>
              <hr />
              <p>
                To change your portal password, please click the button below to receive an OTP to your registered cellphone number and email, then you can proceed.
              </p>
              <div style={{ textAlign: 'left', margin: '0' }}>
                <button
                  className="btn btn-primary"
                  // style={{ width: '30%', backgroundColor: '#e56521', borderColor: '#ec4d13' }}
                  onClick={handlePortalPasswordReset}
                >
                  Reset Password
                </button>
              </div>
            </div>
        </div>

        {/* Password Reset Modal Placeholder */}
            {showPasswordResetModal && (
              <div className="modal show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header text-white" style={{ backgroundColor: '#e2520f' }}>
                      <h5 className="modal-title">Confirm Password Reset</h5>
                      <button type="button" className="btn-close" onClick={() => setShowPasswordResetModal(false)} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handlePasswordResetSubmit}>
                        <div className="mb-0">
                          <label htmlFor="confirmationPin" className="form-label">OTP</label>
                          <input
                            type="text"
                            id="confirmationPin"
                            className="form-control"
                            value={confirmationPin}
                            onChange={(e) => setConfirmationPin(e.target.value)}
                            required
                            minLength={4}
                            maxLength={4}
                          />
                        </div>
                        {/* Old Password Field */}
                        <div className="mb-3">
                          <label htmlFor="oldPassword" className="form-label">Old Password</label>
                          <div className="input-group">
                            <input
                              type={showOldPassword ? "text" : "password"}
                              id="oldPassword"
                              className="form-control"
                              value={oldPassword}
                              onChange={(e) => setOldPassword(e.target.value)}
                              required
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowOldPassword(!showOldPassword)}
                              tabIndex={-1}
                              style={{
                                backgroundColor: "#6c757d",
                                borderColor: "#6c757d",
                                color: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            >
                              <i className={`bi ${showOldPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                          </div>
                        </div>

                        {/* New Password Field */}
                        <div className="mb-3">
                          <label htmlFor="newPassword" className="form-label">New Password</label>
                          <div className="input-group">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              id="newPassword"
                              className="form-control"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                              minLength={6}
                              maxLength={20}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowNewPassword(!showNewPassword)}
                              tabIndex={-1}
                              style={{
                                backgroundColor: "#6c757d",
                                borderColor: "#6c757d",
                                color: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            >
                              <i className={`bi ${showNewPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                          </div>
                        </div>

                        {/* Confirm New Password Field */}
                        <div className="mb-3">
                          <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                          <div className="input-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              id="confirmPassword"
                              className="form-control"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                              minLength={6}
                              maxLength={20}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              tabIndex={-1}
                              style={{
                                backgroundColor: "#6c757d",
                                borderColor: "#6c757d",
                                color: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            >
                              <i className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                          </div>
                        </div>

                        {passwordResetError && <div className="alert alert-danger">{passwordResetError}</div>}
                        {passwordResetSuccess && <div className="alert alert-success">{passwordResetSuccess}</div>}

                        <div className="d-flex justify-content-between">
                          <button
                            type="button"
                            className="btn text-white btn-secondary"
                            onClick={handleResendPortalOTP}
                          >
                            Resend OTP
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            style={{ backgroundColor: '#e56521', borderColor: '#ec4d13' }}
                          >
                            Submit
                          </button>
                        </div>


                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {showRouterUpdateModal && (
              <div className="modal show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header text-white" style={{ backgroundColor: '#e2520f' }}>
                      <h5 className="modal-title">Update Router Details</h5>
                      <button type="button" className="btn-close" onClick={() => setShowRouterUpdateModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleRouterUpdateSubmit}>
                        <div className="mb-3">
                          <label htmlFor="ssid" className="form-label">WiFi SSID</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ssid"
                            value={newRouterSSID}
                            onChange={(e) => setNewRouterSSID(e.target.value)}
                            required
                            minLength={4}
                            maxLength={32}
                          />
                        </div>

                        {/* Password Field with Toggle */}
                        <div className="mb-3">
                          <label htmlFor="wifiPassword" className="form-label">WiFi Password</label>
                          <div className="input-group">
                            <input
                              type={showWifiPassword ? "text" : "password"}
                              className="form-control"
                              id="wifiPassword"
                              value={newRouterPassword}
                              onChange={(e) => setNewRouterPassword(e.target.value)}
                              required
                              minLength={8}
                              maxLength={63}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowWifiPassword(!showWifiPassword)}
                              tabIndex={-1}
                              style={{
                                backgroundColor: "#6c757d",
                                borderColor: "#6c757d",
                                color: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            >
                              <i className={`bi ${showWifiPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                          </div>
                        </div>

                        {/* Confirm Password Field with Toggle */}
                        <div className="mb-3">
                          <label htmlFor="confirmWifiPassword" className="form-label">Confirm WiFi Password</label>
                          <div className="input-group">
                            <input
                              type={showConfirmWifiPassword ? "text" : "password"}
                              className="form-control"
                              id="confirmWifiPassword"
                              value={confirmRouterPassword}
                              onChange={(e) => setConfirmRouterPassword(e.target.value)}
                              required
                              minLength={8}
                              maxLength={63}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowConfirmWifiPassword(!showConfirmWifiPassword)}
                              tabIndex={-1}
                              style={{
                                backgroundColor: "#6c757d",
                                borderColor: "#6c757d",
                                color: "white",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            >
                              <i className={`bi ${showConfirmWifiPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </button>
                          </div>
                        </div>

                        {routerUpdateError && <div className="alert alert-danger">{routerUpdateError}</div>}
                        {routerUpdateSuccess && <div className="alert alert-success">{routerUpdateSuccess}</div>}

                        <div className="d-flex justify-content-between">
                          <button type="button" className="btn btn-secondary" onClick={() => setShowRouterUpdateModal(false)}>
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            style={{ backgroundColor: "#e56521", borderColor: "#ec4d13" }}
                            disabled={isUpdating}
                          >
                            {isUpdating ? "Saving..." : "Save Changes"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <br/>
            <br/>
            <br/>

        </Layout>
    );
};

export default Profile;